import { useEffect } from "react";
import { SITE_NAME, SITE_URL, seoForPath } from "../data/seo";

/* Runtime head manager for client-side navigation. The build-time prerender
   (scripts/prerender.js) writes the same tags into each route's static HTML. */
export function headTagsFor(path) {
  const seo = seoForPath(path);
  if (!seo) return null;
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  return {
    title: seo.title,
    canonical: url,
    metas: [
      { name: "description", content: seo.description },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1" },
      { property: "og:type", content: seo.type },
      { property: "og:site_name", content: SITE_NAME },
      { property: "og:title", content: seo.title },
      { property: "og:description", content: seo.description },
      { property: "og:url", content: url },
      { property: "og:image", content: seo.image },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: seo.imageAlt },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: seo.title },
      { name: "twitter:description", content: seo.description },
      { name: "twitter:image", content: seo.image },
    ],
    jsonLd: seo.jsonLd,
  };
}

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export const Seo = ({ path }) => {
  useEffect(() => {
    const tags = headTagsFor(path);
    if (!tags) return;
    document.title = tags.title;
    tags.metas.forEach((m) => upsertMeta(m.name ? "name" : "property", m.name || m.property, m.content));
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", tags.canonical);
    let script = document.head.querySelector('script[type="application/ld+json"][data-seo]');
    if (!script) {
      document.head.querySelectorAll('script[type="application/ld+json"]').forEach((s) => s.remove());
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "true");
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(tags.jsonLd);
  }, [path]);
  return null;
};
